import type { ReactNode } from "react";

export interface AppShellProps {
  banner?: ReactNode;

  nav: ReactNode;
  children: ReactNode;
}

export function AppShell({ banner, nav, children }: Readonly<AppShellProps>) {
  return (
    <div className="flex h-dvh flex-col">
      {banner}
      <div className="flex min-h-0 flex-1">
        {nav}
        <main className="min-w-0 flex-1 overflow-y-auto bg-surface-base">{children}</main>
      </div>
    </div>
  );
}
